
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.3 7.295a1 1 0 011-.995h29.5a1 1 0 011 1v19.4a1 1 0 01-1 1H2.2a1 1 0 01-1-1.005l.1-19.4zM3.295 8.3l-.09 17.4H30.8V8.3H3.295z","fill":"#47AEA6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.9 14.8a1 1 0 011-1h6.7a1 1 0 110 2h-6.7a1 1 0 01-1-1z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M11.4 12.3l1.6 3.1 3.4.5-2.5 2.4.6 3.4-3.1-1.6-3 1.6.6-3.4-2.5-2.4 3.4-.5 1.5-3.1z","fill":"#F9A91E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.9 19.2a1 1 0 011-1h6.7a1 1 0 110 2h-6.7a1 1 0 01-1-1z","fill":"#47AEA6"}})])
          )
        }
      }
    